// extracted by mini-css-extract-plugin
module.exports = {"mecha":"index-mecha-2OqcV","btnDetail":"index-btnDetail-3YxbU","active":"index-active-16EIs"};